module.exports = __webpack_public_path__ + "img/omg2.598d9fb8.png";